exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboard {\n  margin: 8px 16px;\n  border: 1px solid transparent;\n  background: white;\n}\n.dashboard__container {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(190px, 1fr));\n}\n.dashboard__title {\n  margin-top: 16px;\n  margin-bottom: 8px;\n  margin-left: 16px;\n  font-weight: 400;\n}", ""]);

